import React from 'react';
import { Switch } from '@mantine/core';

/**
 * Champ Puck booléen — Switch Mantine compact (remplace l'ancien radio
 * Oui/Non à deux grosses cartes). Libellé à gauche, interrupteur à droite,
 * comme une ligne du classique (INSPECTOR_ROWS_CSS).
 * `description` optionnelle : texte d'aide affiché sous le switch.
 */
export function puckSwitchField(label, description) {
  return {
    type: 'custom',
    label,
    render: ({ value, onChange }) => (
      <Switch
        size="sm"
        label={label}
        description={description}
        checked={!!value}
        onChange={(e) => onChange(e.currentTarget.checked)}
      />
    ),
  };
}
